import styled from "styled-components";

const Appwrapper = styled.div`
    width : 100%;
    height:100%;
    overflow-x:hidden;
`;

export default Appwrapper;
